var _path, _g, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _path18, _path19, _path20, _circle2, _circle3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _polygon, _polygon2, _polygon3, _g2, _rect11, _rect12, _rect13, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _rect14, _polygon4, _rect15, _rect16, _path125, _path126, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path127, _path128, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _path129, _path130, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _path131, _path132, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _path133, _path134, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _path135, _path136, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _path137, _path138, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _circle4, _circle5, _circle6, _path139, _path140, _path141, _rect103, _rect104, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _polygon5, _path175, _path176, _path177, _path178, _ellipse, _ellipse2, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _line, _path203, _path204, _path205, _g3, _path206, _polygon6, _path207, _path208, _path209, _rect105, _path210, _path211, _path212, _path213, _path214, _path215, _path216;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg500(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.75,385.23C43,449.42,70.37,510.41,117.46,554.11c39.67,36.81,83.26,59.67,122.64,73.87q3.77,1.37,7.49,2.62a404.07,404.07,0,0,0,79.9,18.17,311.74,311.74,0,0,0,33.16,2.37c2.37,0,4.75.13,7.12.3l1.65.12q6.29.53,12.48.93,4.78.32,9.52.56C450,656.11,501.87,651.41,547,642.41c2.86-.57,5.7-1.16,8.5-1.77q13.86-3,26.83-6.47,8.54-2.28,16.69-4.75l.31-.09q9.3-2.82,18.09-5.83c13-4.44,25.12-9.15,36.44-14q12.52-5.37,23.72-10.9c61.5-30.27,92.52-61.66,92.52-61.66,96.21-115.11,37.76-230.53,37.76-230.53-21.58-72.84-173.53-113.84-173.53-113.84-85.43-21.57-134-70.14-134-70.14C333.07-52.9,165.83,72.08,165.83,72.08,52.11,144.93,37.49,292.78,40.75,385.23Z",
    fill: "#00c099"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.75,385.23C43,449.42,70.37,510.41,117.46,554.11c39.67,36.81,83.26,59.67,122.64,73.87q3.77,1.37,7.49,2.62a404.07,404.07,0,0,0,79.9,18.17,311.74,311.74,0,0,0,33.16,2.37c2.37,0,4.75.13,7.12.3l1.65.12q6.29.53,12.48.93,4.78.32,9.52.56C450,656.11,501.87,651.41,547,642.41c2.86-.57,5.7-1.16,8.5-1.77q13.86-3,26.83-6.47,8.54-2.28,16.69-4.75l.31-.09q9.3-2.82,18.09-5.83c13-4.44,25.12-9.15,36.44-14q12.52-5.37,23.72-10.9c61.5-30.27,92.52-61.66,92.52-61.66,96.21-115.11,37.76-230.53,37.76-230.53-21.58-72.84-173.53-113.84-173.53-113.84-85.43-21.57-134-70.14-134-70.14C333.07-52.9,165.83,72.08,165.83,72.08,52.11,144.93,37.49,292.78,40.75,385.23Z",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 317.6,
    y: 464.85,
    width: 180.76,
    height: 127.95,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 317.6,
    y: 464.85,
    width: 180.76,
    height: 127.95,
    opacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 291.21,
    y: 451.63,
    width: 197.6,
    height: 49.03,
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.79,464.85a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,353.79,464.85Z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M363.64,464.85a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,363.64,464.85Z",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.49,464.85a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,373.49,464.85Z",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.34,464.85a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,383.34,464.85Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M459.66,464.85a2.24,2.24,0,1,1-2.23-2.23h0a2.23,2.23,0,0,1,2.23,2.21Z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M469.7,464.85a2.23,2.23,0,1,1-2.23-2.23h0a2.22,2.22,0,0,1,2.23,2.21Z",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M393.19,464.85a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,393.19,464.85Z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M441.56,464.85a2.25,2.25,0,1,1-2.25-2.23h0a2.23,2.23,0,0,1,2.24,2.22Z",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M403,464.85a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,403,464.85Z",
    fill: "#f5f5f5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M412.89,464.85a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,412.89,464.85Z",
    fill: "#f5f5f5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M432.87,464.85a2.24,2.24,0,1,1-2.25-2.23h0a2.23,2.23,0,0,1,2.24,2.22Z",
    fill: "#f5f5f5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M477.88,464.85a2.25,2.25,0,1,1-2.26-2.23h0a2.24,2.24,0,0,1,2.24,2.22Z",
    fill: "#f5f5f5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M422.74,464.85a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,422.74,464.85Z",
    fill: "#00c099"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M450.88,464.85a2.23,2.23,0,1,1-2.23-2.23h0a2.23,2.23,0,0,1,2.23,2.21Z",
    fill: "#00c099"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M473.41,475.62a2.24,2.24,0,1,1,2.25,2.23h0A2.23,2.23,0,0,1,473.41,475.62Z",
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 465.79,
    cy: 475.62,
    r: 2.23,
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M453.71,475.62a2.25,2.25,0,1,1,2.25,2.23h0a2.24,2.24,0,0,1-2.24-2.22Z",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M443.86,475.62a2.25,2.25,0,1,1,2.26,2.23h0a2.24,2.24,0,0,1-2.24-2.22Z",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M367.54,475.62a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,367.54,475.62Z",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M357.5,475.62a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,357.5,475.62Z",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.25,
    cy: 475.62,
    r: 2.23,
    opacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 387.88,
    cy: 475.62,
    r: 2.23,
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M424.16,475.62a2.25,2.25,0,1,1,2.26,2.23h0a2.24,2.24,0,0,1-2.24-2.22Z",
    fill: "#f5f5f5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M414.35,475.62a2.23,2.23,0,1,1,2.23,2.23h0a2.23,2.23,0,0,1-2.23-2.21Z",
    fill: "#f5f5f5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M394.34,475.62a2.23,2.23,0,1,1,2.23,2.23h0a2.22,2.22,0,0,1-2.23-2.21Z",
    fill: "#f5f5f5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M349.33,475.62a2.23,2.23,0,1,1,2.23,2.23h0a2.23,2.23,0,0,1-2.23-2.21Z",
    fill: "#f5f5f5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M404.47,475.62a2.24,2.24,0,1,1,2.23,2.23h0a2.23,2.23,0,0,1-2.23-2.21Z",
    fill: "#00c099"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M376.27,475.62a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,376.27,475.62Z",
    fill: "#00c099"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M353.79,485.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,353.79,485.18Z",
    opacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M363.64,485.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,363.64,485.18Z",
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M373.49,485.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,373.49,485.18Z",
    opacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M383.34,485.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,383.34,485.18Z",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M459.66,485.18a2.24,2.24,0,1,1-2.23-2.23h0a2.22,2.22,0,0,1,2.23,2.2Z",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M469.7,485.18a2.23,2.23,0,1,1-2.23-2.23h0a2.21,2.21,0,0,1,2.23,2.2Z",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M393.19,485.18A2.23,2.23,0,1,1,391,483h0A2.23,2.23,0,0,1,393.19,485.18Z",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M441.56,485.18a2.25,2.25,0,1,1-2.25-2.23h0a2.22,2.22,0,0,1,2.24,2.22Z",
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M403,485.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,403,485.18Z",
    fill: "#f5f5f5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M412.89,485.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,412.89,485.18Z",
    fill: "#f5f5f5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M432.87,485.18a2.24,2.24,0,1,1-2.25-2.23h0a2.22,2.22,0,0,1,2.24,2.22Z",
    fill: "#f5f5f5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M477.88,485.18a2.25,2.25,0,1,1-2.26-2.23h0a2.23,2.23,0,0,1,2.24,2.22Z",
    fill: "#f5f5f5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M422.74,485.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,422.74,485.18Z",
    fill: "#00c099"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M450.88,485.18a2.23,2.23,0,1,1-2.23-2.23h0a2.22,2.22,0,0,1,2.23,2.2Z",
    fill: "#00c099"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 299.99,
    y: 461.72,
    width: 38.9,
    height: 5.99,
    opacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 299.99,
    y: 472.03,
    width: 38.9,
    height: 5.99,
    opacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 299.99,
    y: 482.67,
    width: 38.9,
    height: 5.99,
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 291.21,
    y: 512.13,
    width: 197.6,
    height: 49.03,
    fill: "#2f2e41"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 299.99,
    y: 522.23,
    width: 38.9,
    height: 5.99,
    opacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 299.99,
    y: 532.52,
    width: 38.9,
    height: 5.99,
    opacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 299.99,
    y: 543.18,
    width: 38.9,
    height: 5.99,
    opacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M353,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,353,525.41Z",
    opacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M362.92,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,362.92,525.41Z",
    opacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M372.77,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,372.77,525.41Z",
    opacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M382.62,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,382.62,525.41Z",
    opacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M458.94,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,458.94,525.41Z",
    opacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M469,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,469,525.41Z",
    opacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M392.47,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,392.47,525.41Z",
    opacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M440.84,526.16a2.24,2.24,0,1,1-2.25-2.23h0A2.25,2.25,0,0,1,440.84,526.16Z",
    opacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M402.32,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,402.32,525.41Z",
    fill: "#f5f5f5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M412.17,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,412.17,525.41Z",
    fill: "#f5f5f5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M432.16,525.41a2.24,2.24,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,432.16,525.41Z",
    fill: "#f5f5f5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M477.16,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,477.16,525.41Z",
    fill: "#f5f5f5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M422,525.41a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,422,525.41Z",
    fill: "#00c099"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M450.22,525.41a2.24,2.24,0,1,1-2.25-2.23h0A2.24,2.24,0,0,1,450.22,525.41Z",
    fill: "#00c099"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M472.7,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,472.7,536.11Z",
    opacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M462.85,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,462.85,536.11Z",
    opacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M453,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,453,536.11Z",
    opacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M443.15,536.86a2.24,2.24,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,443.15,536.86Z",
    opacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M366.82,536.11a2.24,2.24,0,1,1,2.23,2.23h0A2.25,2.25,0,0,1,366.82,536.11Z",
    opacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M356.78,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.25,2.25,0,0,1,356.78,536.11Z",
    opacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M433.3,536.86a2.24,2.24,0,1,1,2.24,2.23h0A2.23,2.23,0,0,1,433.3,536.86Z",
    opacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M384.93,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.25,2.25,0,0,1,384.93,536.11Z",
    opacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M423.48,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,423.48,536.11Z",
    fill: "#f5f5f5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M413.61,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,413.61,536.11Z",
    fill: "#f5f5f5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M393.62,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.25,2.25,0,0,1,393.62,536.11Z",
    fill: "#f5f5f5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M348.61,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,348.61,536.11Z",
    fill: "#f5f5f5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M403.76,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.23,2.23,0,0,1,403.76,536.11Z",
    fill: "#00c099"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M375.55,536.11a2.23,2.23,0,1,1,2.23,2.23h0A2.25,2.25,0,0,1,375.55,536.11Z",
    fill: "#00c099"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M353,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,353,545.68Z",
    opacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M362.92,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,362.92,545.68Z",
    opacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M372.77,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,372.77,545.68Z",
    opacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M382.62,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,382.62,545.68Z",
    opacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M458.94,546.44a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,458.94,546.44Z",
    opacity: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M469,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,469,545.68Z",
    opacity: 0.2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M392.47,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,392.47,545.68Z",
    opacity: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M440.84,546.44a2.24,2.24,0,1,1-2.25-2.23h0A2.23,2.23,0,0,1,440.84,546.44Z",
    opacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M402.32,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,402.32,545.68Z",
    fill: "#f5f5f5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M412.17,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,412.17,545.68Z",
    fill: "#f5f5f5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M432.16,545.68a2.24,2.24,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,432.16,545.68Z",
    fill: "#f5f5f5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M477.16,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,477.16,545.68Z",
    fill: "#f5f5f5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M422,545.68a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,422,545.68Z",
    fill: "#00c099"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M450.22,545.68a2.24,2.24,0,1,1-2.25-2.23h0A2.24,2.24,0,0,1,450.22,545.68Z",
    fill: "#00c099"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "518.52 500.19 488.81 500.27 488.81 451.25 518.52 451.17 518.52 500.19",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "518.52 561.08 488.81 561.16 488.81 512.13 518.52 512.05 518.52 561.08",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "516.69 622.42 486.99 622.5 486.99 573.47 516.69 573.38 516.69 622.42",
    fill: "#2f2e41"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "518.52 500.19 488.81 500.27 488.81 451.25 518.52 451.17 518.52 500.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.52 561.08 488.81 561.16 488.81 512.13 518.52 512.05 518.52 561.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.69 622.42 486.99 622.5 486.99 573.47 516.69 573.38 516.69 622.42"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 290.82,
    y: 573.47,
    width: 197.6,
    height: 49.03,
    fill: "#2f2e41"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 299.59,
    y: 583.57,
    width: 38.9,
    height: 5.99,
    opacity: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 299.59,
    y: 593.86,
    width: 38.9,
    height: 5.99,
    opacity: 0.2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M353.88,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,353.88,587.18Z",
    opacity: 0.2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M363.73,587.18A2.23,2.23,0,1,1,361.5,585h0A2.24,2.24,0,0,1,363.73,587.18Z",
    opacity: 0.2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M373.58,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,373.58,587.18Z",
    opacity: 0.2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M383.43,587.18A2.23,2.23,0,1,1,381.2,585h0A2.25,2.25,0,0,1,383.43,587.18Z",
    opacity: 0.2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M459.75,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,459.75,587.18Z",
    opacity: 0.2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M469.79,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,469.79,587.18Z",
    opacity: 0.2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M393.28,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.25,2.25,0,0,1,393.28,587.18Z",
    opacity: 0.2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,441.64,587.18Z",
    opacity: 0.2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M403.13,587.18A2.23,2.23,0,1,1,400.9,585h0A2.25,2.25,0,0,1,403.13,587.18Z",
    fill: "#f5f5f5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M413,587.18a2.24,2.24,0,1,1-2.25-2.23h0A2.24,2.24,0,0,1,413,587.18Z",
    fill: "#f5f5f5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M433,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,433,587.18Z",
    fill: "#f5f5f5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M478,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,478,587.18Z",
    fill: "#f5f5f5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M422.83,587.18a2.25,2.25,0,1,1-2.26-2.23h0A2.25,2.25,0,0,1,422.83,587.18Z",
    fill: "#00c099"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M451,587.18a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,451,587.18Z",
    fill: "#00c099"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M473.5,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.25,2.25,0,0,1,473.5,597.94Z",
    opacity: 0.2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M463.65,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.25,2.25,0,0,1,463.65,597.94Z",
    opacity: 0.2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M453.8,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.25,2.25,0,0,1,453.8,597.94Z",
    opacity: 0.2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M444,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.25,2.25,0,0,1,444,597.94Z",
    opacity: 0.2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M367.63,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.23,2.23,0,0,1,367.63,597.94Z",
    opacity: 0.2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M357.59,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.25,2.25,0,0,1,357.59,597.94Z",
    opacity: 0.2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M434.1,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.25,2.25,0,0,1,434.1,597.94Z",
    opacity: 0.2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M385.74,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.23,2.23,0,0,1,385.74,597.94Z",
    opacity: 0.2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M424.25,597.94a2.25,2.25,0,1,1,2.26,2.24h0A2.25,2.25,0,0,1,424.25,597.94Z",
    fill: "#f5f5f5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M414.35,597.94a2.25,2.25,0,1,1,2.26,2.24h0A2.25,2.25,0,0,1,414.35,597.94Z",
    fill: "#f5f5f5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M394.43,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.23,2.23,0,0,1,394.43,597.94Z",
    fill: "#f5f5f5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M349.42,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.23,2.23,0,0,1,349.42,597.94Z",
    fill: "#f5f5f5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M404.55,597.94a2.25,2.25,0,1,1,2.26,2.24h0A2.25,2.25,0,0,1,404.55,597.94Z",
    fill: "#00c099"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M376.36,597.94a2.23,2.23,0,1,1,2.23,2.24h0A2.23,2.23,0,0,1,376.36,597.94Z",
    fill: "#00c099"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M353.88,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,353.88,607.51Z",
    opacity: 0.2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M363.73,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,363.73,607.51Z",
    opacity: 0.2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M373.58,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,373.58,607.51Z",
    opacity: 0.2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M383.43,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,383.43,607.51Z",
    opacity: 0.2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M459.75,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,459.75,607.51Z",
    opacity: 0.2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M469.79,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,469.79,607.51Z",
    opacity: 0.2
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M393.28,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,393.28,607.51Z",
    opacity: 0.2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,441.64,607.51Z",
    opacity: 0.2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M403.13,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.24,2.24,0,0,1,403.13,607.51Z",
    fill: "#f5f5f5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M413,607.51a2.24,2.24,0,1,1-2.25-2.23h0A2.23,2.23,0,0,1,413,607.51Z",
    fill: "#f5f5f5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M433,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,433,607.51Z",
    fill: "#f5f5f5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M478,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,478,607.51Z",
    fill: "#f5f5f5"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M422.83,607.51a2.25,2.25,0,1,1-2.26-2.23h0A2.24,2.24,0,0,1,422.83,607.51Z",
    fill: "#00c099"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M451,607.51a2.23,2.23,0,1,1-2.23-2.23h0A2.23,2.23,0,0,1,451,607.51Z",
    fill: "#00c099"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 525.45,
    y: 175.06,
    width: 146.06,
    height: 447.42,
    fill: "#e1e1e2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "786.74 622.5 671.5 622.5 671.29 175.06 786.74 175.06 786.74 622.5",
    fill: "#9ea0a3"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 533.53,
    y: 246.67,
    width: 123.89,
    height: 34.88,
    fill: "#2f2e41"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 536.99,
    y: 251.06,
    width: 6.94,
    height: 26.69,
    opacity: 0.2
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,256.67a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,266.1a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 560.92,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 570.77,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 580.62,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 590.45,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 600.3,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 610.15,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 629.85,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 639.7,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 649.55,
    y: 254.47,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 533.53,
    y: 296.79,
    width: 123.89,
    height: 34.88,
    fill: "#2f2e41"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 536.99,
    y: 301.17,
    width: 6.94,
    height: 26.69,
    opacity: 0.2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,306.78a2.21,2.21,0,1,1-2.21-2.2,2.2,2.2,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,316.21a2.21,2.21,0,1,1-2.27-2.14h.06A2.21,2.21,0,0,1,552.1,316.21Z",
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 560.92,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 570.77,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 580.62,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 590.45,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 600.3,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 610.15,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 629.85,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 639.7,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 649.55,
    y: 304.58,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 533.53,
    y: 347.3,
    width: 123.89,
    height: 34.88,
    fill: "#2f2e41"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 536.99,
    y: 351.68,
    width: 6.94,
    height: 26.69,
    opacity: 0.2
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,357.29a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,366.72a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 560.92,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 570.77,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 580.62,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 590.45,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 600.3,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 610.15,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 629.85,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 639.7,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 649.55,
    y: 355.09,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 533.53,
    y: 401.86,
    width: 123.89,
    height: 34.88,
    fill: "#2f2e41"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 536.99,
    y: 406.25,
    width: 6.94,
    height: 26.69,
    opacity: 0.2
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,411.91a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,421.29a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 560.92,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 570.77,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 580.62,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 590.45,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 600.3,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 610.15,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 629.85,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 639.7,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 649.55,
    y: 409.66,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 533.53,
    y: 456.96,
    width: 123.89,
    height: 34.88,
    fill: "#2f2e41"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 536.99,
    y: 461.36,
    width: 6.94,
    height: 26.69,
    opacity: 0.2
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,467a2.21,2.21,0,1,1-2.21-2.21A2.21,2.21,0,0,1,552.1,467Z",
    fill: "#fff"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,476.4a2.21,2.21,0,1,1-2.21-2.21,2.2,2.2,0,0,1,2.21,2.21Z",
    fill: "#fff"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 560.92,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 570.77,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 580.62,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 590.45,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 600.3,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 610.15,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 629.85,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 639.7,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 649.55,
    y: 464.76,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 533.53,
    y: 566.64,
    width: 123.89,
    height: 34.88,
    fill: "#2f2e41"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 536.99,
    y: 571.02,
    width: 6.94,
    height: 26.69,
    opacity: 0.2
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,576.64a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,586.07a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 560.92,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 570.77,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 580.62,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 590.45,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 600.3,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 610.15,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 629.85,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 639.7,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 649.55,
    y: 574.44,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 533.53,
    y: 511.84,
    width: 123.89,
    height: 34.88,
    fill: "#2f2e41"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 536.99,
    y: 516.24,
    width: 6.94,
    height: 26.69,
    opacity: 0.2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,521.85a2.21,2.21,0,1,1-2.21-2.2,2.2,2.2,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1,531.28a2.21,2.21,0,1,1-2.21-2.2,2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fff"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 560.92,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 570.77,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 580.62,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 590.45,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 600.3,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 610.15,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 629.85,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 639.7,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 649.55,
    y: 519.65,
    width: 6.82,
    height: 20.51,
    opacity: 0.2
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 535.23,
    y: 180.63,
    width: 120.49,
    height: 17.49,
    fill: "#2f2e41"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 561.74,
    y: 189.37,
    width: 65.61,
    height: 8.74,
    opacity: 0.2
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 649.34,
    y: 603.63,
    width: 9.89,
    height: 12.03,
    fill: "#2f2e41"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 704.89,
    y: 513,
    width: 55.47,
    height: 60.78,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.62,
    cy: 543.64,
    r: 18.26,
    opacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.62,
    cy: 543.64,
    r: 9.13,
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 712.39,
    cy: 522.44,
    r: 1.7,
    opacity: 0.2
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M753.53,522.44a1.7,1.7,0,1,1-1.69-1.7h0A1.69,1.69,0,0,1,753.53,522.44Z",
    opacity: 0.2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M753.93,567.31a1.7,1.7,0,1,1-1.7-1.69h0A1.7,1.7,0,0,1,753.93,567.31Z",
    opacity: 0.2
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M714.08,568a1.7,1.7,0,1,1-1.69-1.7h0A1.69,1.69,0,0,1,714.08,568Z",
    opacity: 0.2
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 760.36,
    y: 513,
    width: 4.47,
    height: 60.78,
    fill: "#2f2e41"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 760.36,
    y: 513,
    width: 4.47,
    height: 60.78,
    opacity: 0.2
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M486,306.62H321.86a5.13,5.13,0,0,0-5.13,5.13V427.67a5.13,5.13,0,0,0,5.13,5.13h63s4,12.38-8.41,18.8h58.9s-14-4.82-10.44-18.8H486a5.13,5.13,0,0,0,5.13-5.13V311.75A5.13,5.13,0,0,0,486,306.62Z",
    fill: "#00c099"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M406.1,420.6a3.15,3.15,0,0,1-4.44,4.45.9.9,0,0,1-.28-.27,3.16,3.16,0,0,1,4.45-4.45A1.15,1.15,0,0,1,406.1,420.6Z",
    opacity: 0.2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M323.28,308.75H484.55a3.72,3.72,0,0,1,3.72,3.72h0v99.14H319.56V312.47a3.71,3.71,0,0,1,3.72-3.72Z",
    fill: "#fff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M323.45,308.75H485.08a3.19,3.19,0,0,1,3.2,3.19h0v5.35H319.56v-4.65A3.91,3.91,0,0,1,323.45,308.75Z",
    fill: "#ebebeb"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M326.11,313.21a1.19,1.19,0,1,1-1.19-1.19h0a1.18,1.18,0,0,1,1.18,1.18Z",
    fill: "#e0e0e0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M329.64,313.21a1.19,1.19,0,1,1-1.18-1.19,1.17,1.17,0,0,1,1.18,1.16Z",
    fill: "#e0e0e0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M333,313.21a1.19,1.19,0,1,1-1.19-1.19,1.19,1.19,0,0,1,1.19,1.19Z",
    fill: "#e0e0e0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M387.94,355.09c0,5.21-3.8,9.71-12.19,9.71a20.18,20.18,0,0,1-11.18-3.14l2.68-5.22a14.17,14.17,0,0,0,8.34,2.61c3.39,0,5.48-1.42,5.48-3.81s-1.5-3.81-6.82-3.81h-7.5l1.51-16.5h17.88v5.44H373.91l-.46,5.57h2.39C384.5,346,387.94,349.89,387.94,355.09Z",
    fill: "#00c099"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M390.7,349.67c0-9.66,5.36-15.16,12.56-15.16s12.56,5.5,12.56,15.16-5.31,15.17-12.56,15.17S390.7,359.31,390.7,349.67Zm18.26,0c0-6.65-2.35-9.42-5.74-9.42s-5.69,2.77-5.69,9.42,2.34,9.43,5.69,9.43,5.78-2.8,5.78-9.43Z",
    fill: "#00c099"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M419.14,349.67c0-9.66,5.36-15.16,12.56-15.16s12.56,5.5,12.56,15.16-5.32,15.17-12.56,15.17S419.14,359.31,419.14,349.67Zm18.26,0c0-6.65-2.35-9.42-5.74-9.42S426,343,426,349.67s2.35,9.43,5.7,9.43,5.78-2.8,5.78-9.43Z",
    fill: "#00c099"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M344.57,371.93h1.24v8.66h-1.24Z",
    fill: "#2f2e41"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M355.85,371.93v8.66h-1l-5.22-6.46v6.46h-1.24v-8.66h1l5.22,6.52v-6.52Z",
    fill: "#2f2e41"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M360.17,373h-3v-1.08h7.17V373h-3v7.58h-1.23Z",
    fill: "#2f2e41"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M372,379.52v1.07h-6.28v-8.66h6.11V373H367v2.61h4.35v1H367v2.81Z",
    fill: "#2f2e41"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M379.8,380.59,377.93,378h-2.72v2.61H374v-8.66h3.37c2.25,0,3.62,1.13,3.62,3a2.73,2.73,0,0,1-1.91,2.73l2.05,2.91Zm0-5.64c0-1.23-.83-1.94-2.41-1.94h-2.18v3.91h2.12c1.6,0,2.44-.73,2.44-2Z",
    fill: "#2f2e41"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M390.46,371.93v8.66h-1l-5.22-6.46v6.46H383v-8.66h1l5.22,6.52v-6.52Z",
    fill: "#2f2e41"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M398.58,378.37H394l-1,2.17h-1.3l3.91-8.66h1.23l3.91,8.66h-1.31Zm-.45-1-1.86-4.23-1.87,4.24Z",
    fill: "#2f2e41"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M402.11,371.93h1.24v7.59H408v1.07h-5.93Z",
    fill: "#2f2e41"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M412,379.68l.47-1a4.44,4.44,0,0,0,2.85,1c1.5,0,2.14-.57,2.14-1.3,0-2.11-5.21-.78-5.21-4,0-1.3,1-2.46,3.31-2.46a5.18,5.18,0,0,1,2.79.75l-.42,1a4.44,4.44,0,0,0-2.37-.71c-1.47,0-2.1.63-2.1,1.38,0,2.12,5.22.79,5.22,3.92,0,1.3-1.07,2.46-3.36,2.46A5.22,5.22,0,0,1,412,379.68Z",
    fill: "#2f2e41"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M426.77,379.52v1.07h-6.3v-8.66h6.12V373h-4.88v2.61h4.38v1h-4.34v2.81Z",
    fill: "#2f2e41"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M434.56,380.59,432.69,378H430v2.61h-1.24v-8.66h3.38c2.26,0,3.62,1.13,3.62,3a2.74,2.74,0,0,1-1.91,2.73l2,2.91Zm0-5.64c0-1.23-.83-1.94-2.42-1.94H430v3.91h2.1c1.6,0,2.42-.73,2.42-2Z",
    fill: "#2f2e41"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M445.28,371.93l-3.8,8.66h-1.22l-3.81-8.66h1.3l3.13,7.12,3.15-7.12Z",
    fill: "#2f2e41"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M452.68,379.52v1.07h-6.29v-8.66h6.1V373h-4.87v2.61H452v1h-4.35v2.81Z",
    fill: "#2f2e41"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M460.47,380.59,458.6,378h-2.69v2.61h-1.24v-8.66h3.38c2.26,0,3.62,1.13,3.62,3a2.74,2.74,0,0,1-1.91,2.73l2.06,2.91Zm0-5.64c0-1.23-.83-1.94-2.42-1.94H456v3.91h2.1c1.55,0,2.38-.73,2.38-2Z",
    fill: "#2f2e41"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M389.72,394.46v1.72h-7.14V387h7v1.71h-4.85v2H389v1.66h-4.29v2.13Z",
    fill: "#2f2e41"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M397.3,396.18l-1.78-2.61h-2v2.61h-2.14V387h4c2.46,0,4,1.3,4,3.34a3,3,0,0,1-1.9,2.91l2.07,3Zm-2-7.49h-1.74v3.21h1.74c1.3,0,2-.6,2-1.6s-.67-1.61-2-1.61Z",
    fill: "#2f2e41"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M407,396.18l-1.78-2.61h-2v2.61h-2.12V387h4c2.47,0,4,1.3,4,3.34a3,3,0,0,1-1.9,2.91l2.07,3Zm-2-7.49h-1.75v3.21H405c1.31,0,2-.6,2-1.6s-.65-1.61-2-1.61Z",
    fill: "#2f2e41"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M410.2,391.56a5.06,5.06,0,1,1,5.34,4.77h-.29a4.78,4.78,0,0,1-5-4.5A2.53,2.53,0,0,1,410.2,391.56Zm7.93,0a2.88,2.88,0,1,0-2.88,2.95,2.8,2.8,0,0,0,2.88-2.75A.67.67,0,0,0,418.13,391.56Z",
    fill: "#2f2e41"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M427.79,396.18,426,393.57h-2v2.61H421.9V387h4c2.47,0,4,1.3,4,3.34a3,3,0,0,1-1.89,2.91l2.06,3Zm-2-7.49H424v3.21h1.74c1.3,0,2-.6,2-1.6s-.67-1.61-2-1.61Z",
    fill: "#2f2e41"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M337,361.8a3,3,0,0,1-2.69-1.56,3.13,3.13,0,0,1,0-3.13l9.07-15.54a3.09,3.09,0,0,1,2.71-1.55h0a3.11,3.11,0,0,1,2.69,1.58l8.92,15.65a3.06,3.06,0,0,1,0,3.12,3.1,3.1,0,0,1-2.71,1.55l-18-.09Zm9.13-20.87h0A2.16,2.16,0,0,0,344.2,342l-9.06,15.54a2.18,2.18,0,0,0,.78,3,2.11,2.11,0,0,0,1.09.3h0l18,.08a2.18,2.18,0,0,0,1.92-3.27L348,342a2.14,2.14,0,0,0-1.92-1Z",
    fill: "#00c099"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M344.72,356.81a1.14,1.14,0,0,1,1.14-1.14h.07a1.13,1.13,0,0,1,1.17,1.07v.08A1.14,1.14,0,0,1,346,358h0a1.16,1.16,0,0,1-1.2-1.12A.09.09,0,0,1,344.72,356.81Zm.11-9.37H347l-.37,7h-1.45Z",
    fill: "#00c099"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M451.82,361.8a3,3,0,0,1-2.69-1.56,3.13,3.13,0,0,1,0-3.13l9.07-15.54a3.09,3.09,0,0,1,2.71-1.55h0a3.11,3.11,0,0,1,2.69,1.58l8.92,15.65a3.06,3.06,0,0,1,0,3.12,3.1,3.1,0,0,1-2.71,1.55l-18-.09ZM461,340.93h0A2.16,2.16,0,0,0,459,342L450,357.55a2.18,2.18,0,0,0,.78,3,2.12,2.12,0,0,0,1.1.3h0l18,.08a2.19,2.19,0,0,0,2.19-2.19,2.16,2.16,0,0,0-.29-1.08L462.84,342a2.14,2.14,0,0,0-1.92-1Z",
    fill: "#00c099"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M459.57,356.81a1.12,1.12,0,0,1,1.13-1.14h.07a1.13,1.13,0,0,1,1.17,1.07v.08A1.14,1.14,0,0,1,460.8,358h0a1.16,1.16,0,0,1-1.2-1.12Zm.1-9.37h2.2l-.37,7H460Z",
    fill: "#00c099"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "169.26 569.09 169.63 595.2 191.47 607.25 191.79 572.87 186.96 560.18 169.26 569.09",
    fill: "#f9b499"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M249.84,571.1,254,589.55a28.5,28.5,0,0,0,24.47-.38l-5.64-27.11Z",
    fill: "#f9b499"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M182.42,76.73a89.13,89.13,0,0,0,7.1-5.8,1.44,1.44,0,0,1,2.33.38c.43.93.6,2.45-.16,5A33.47,33.47,0,0,0,182.42,76.73Z",
    fill: "#f7a48b"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M312.66,159.73l-32,28.62s-16.95,9.79-16.19,50.45c0,0-1.13,10.44,1,29.62.33,3,.74,6.15,1.25,9.54a130.4,130.4,0,0,1,1.1,20.85A103,103,0,0,1,266,316.37s-1.9,4.77.42,11.39c.2.58.44,1.18.71,1.79,0,0,9,7.52-5.26,7.54h-1.14A45.87,45.87,0,0,1,248,331.43a47.67,47.67,0,0,1-10.63-9s-11.48-9.42-25.86-11.08a35.59,35.59,0,0,0-5.77-.21s-1.9,0-4.87-.06c-8.35-.21-25.19-1.25-32.41-6a12.28,12.28,0,0,1-5.83.43c-2.25-.5-4.38-2.05-4.71-6.08l1.5-32.75-.83-12.33-2.93-43.4s0-4.14-8.66-10.92c0,0-14.44-11.9-26.94-23.86-6.76-6.46-13-12.94-16-17.56,0,0-14.68-18.45-.75-27.49l52.21-26.73s5.78,3,14.06,17.32A48.85,48.85,0,0,0,158,130.51a30,30,0,0,0-2.4,2.86s-7.16,9-9.79,10.54c0,0,2.89.49,7.71,4.34a54.53,54.53,0,0,0,15.71,8.89l.36.13a36.45,36.45,0,0,0,10.72,2.27l50.22,20.9,14.22-20.28,16.66-8.72s7.53-7.15,14.68-8.66L255.8,120.19s6.78-13.18,14.31-18.45l36.14,26.36S330,141.65,312.66,159.73Z",
    fill: "#00c099"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M240,125.09c0,11.29-2.93,21.55-7.71,29.12-5.07,8-12.23,13-20.15,13s-14.9-4.88-20-12.74c-4.89-7.59-7.91-18-7.91-29.43,0-23.3,12.48-42.18,27.87-42.18S240,101.79,240,125.09Z",
    fill: "#f9b499"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.31,
    cy: 129.23,
    rx: 6.59,
    ry: 9.41,
    transform: "translate(-28.54 55.59) rotate(-16.02)",
    fill: "#f9b499"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.3,
    cy: 128.85,
    rx: 9.41,
    ry: 6.59,
    transform: "translate(34.53 307.94) rotate(-69)",
    fill: "#f9b499"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M180.82,100.44c.83,3.56,2.79,6.74,7.2,6.57,0,0,4.14-.37,6.78-6,0,0,3.39,2.63-.76,7.53,0,0,15.82,3.39,18.45-13.93,0,0,0-2.26,3.77,1.13,0,0,10.54,9,12.42,14.3A42.91,42.91,0,0,0,226.8,99.1a45,45,0,0,0,17.7,6.41S247.89,78,216.26,78.77c0,0,0-4.52,3-5.65,0,0-3.39-.75-7.53,3,0,0-.75-3.77-6-3.39l2.63,3-10.16-4.9s0,5.65,4.51,8.29A17.43,17.43,0,0,0,186,83.67,17.62,17.62,0,0,0,180.82,100.44Z",
    fill: "#2f2e41"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M180.37,98s-2.49,25.58,9.17,36.32c0,0-3.4-19.38-1.52-27.29C188,107,181.87,107,180.37,98Z",
    fill: "#2f2e41"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M180.37,98s-2.49,25.58,9.17,36.32c0,0-3.4-19.38-1.52-27.29C188,107,181.87,107,180.37,98Z",
    opacity: 0.2
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M236.05,103.41s.74,2,1.41,4.22a8.77,8.77,0,0,1,0,4.82c-1.42,5.07-4.13,17.33,2.11,19.41,0,0-2.52-9.84,4.2-12.07,0,0,1.45-9.39.7-14.28C244.5,105.51,238.91,104.7,236.05,103.41Z",
    fill: "#2f2e41"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M236.05,103.41s.74,2,1.41,4.22a8.77,8.77,0,0,1,0,4.82c-1.42,5.07-4.13,17.33,2.11,19.41,0,0-2.52-9.84,4.2-12.07,0,0,1.45-9.39.7-14.28C244.5,105.51,238.91,104.7,236.05,103.41Z",
    opacity: 0.2
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M232.4,154.22c-.81,13.69-13.88,24-13.88,24l-3,8.28h-3.39l-2.64-9c-12.92-7.16-16.94-21.49-17.32-22.91,5.06,7.86,12.14,12.74,20,12.74s15.08-5,20.15-13Z",
    fill: "#f7a48b"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M190.15,151.19,179,156.72l17.7,40.66a43.43,43.43,0,0,0,12.8-19.95s-11.66-5.52-17.32-22.91Z",
    fill: "#00c099"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M209.48,177.43a45.74,45.74,0,0,1-4.3,9.64c-.54.91-1.09,1.77-1.64,2.56a37.23,37.23,0,0,1-6.86,7.75L179,156.72l11.17-5.53,2,3.33C197.82,171.91,209.48,177.43,209.48,177.43Z",
    fill: "#fff",
    opacity: 0.4
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M218.52,178.18s0,4.52,4.52,10.17l4.89,6.4S241.38,182,245.42,158a1.52,1.52,0,0,0-1-1.69l-11.25-3.52-.85,1.41S232.33,165.75,218.52,178.18Z",
    fill: "#00c099"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M218.52,178.18s0,4.52,4.52,10.17l4.89,6.4S241.38,182,245.42,158a1.52,1.52,0,0,0-1-1.69l-11.25-3.52-.85,1.41S232.33,165.75,218.52,178.18Z",
    fill: "#fff",
    opacity: 0.4
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M169.63,157.27c-11.78,1.64-24.16-4.7-24.16-4.7a56.77,56.77,0,0,0-24.9-3.51C137,146.94,158,130.41,158,130.41l.06.1a31.47,31.47,0,0,0-2.39,2.86s-7.16,9-9.79,10.54c0,0,2.89.49,7.71,4.34a54.53,54.53,0,0,0,15.71,8.89Z",
    opacity: 0.2
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M234,274.2l-8.66,10.92s-6.8-6.26-11.85-9.06a16.68,16.68,0,0,1-8-9.73,34.94,34.94,0,0,1-1.28-11s3.39-51.21,3.77-62.88c0,0-3.34-.63-4.44-2.86.55-.79,1.1-1.65,1.64-2.56.62.57,2.67,1.83,6.94-.61h3.39s2.61,1.66,5.63-1.06l1.9,2.95s-2.64,2.63-5.65,2.25C217.39,190.6,219.27,242.19,234,274.2Z",
    fill: "#2f2e41"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M162.41,218.47A191.52,191.52,0,0,0,159,254.82l-.41-.48-2.93-43.4s0-4.14-8.66-10.92c0,0-14.44-11.9-26.95-23.86l-.09-.35A63.38,63.38,0,0,0,153,192.86S168.44,189.47,162.41,218.47Z",
    opacity: 0.2
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M264.46,238.8s-1.13,10.44,1,29.62l-.11.54c-29.22-90.71,15.29-80.61,15.29-80.61S263.7,198.14,264.46,238.8Z",
    opacity: 0.2
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M200.84,311c-8.34-.21-25.18-1.25-32.4-6C168.44,305.07,193.6,302,200.84,311Z",
    opacity: 0.2
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M276.88,563.38c-15.81,13.93-35,9.79-35,9.79l-14.31-81.71c-11.3-31.63-16.57-99.41-16.57-97.9s-7.16,79.07-7.16,79.07L202,561.5c-.75,15.44-18.82,10.92-18.82,10.92L168.06,569l-3.76-72.67c-3.93-52.23-2.6-143.15-1.93-177.16.17-8.42.3-13.35.3-13.35l-.06-.35a12.28,12.28,0,0,0,5.83-.43c7.22,4.72,24.06,5.76,32.41,6,3,.08,4.87.06,4.87.06,16.94-.76,31.63,11.29,31.63,11.29a48.63,48.63,0,0,0,23.34,14.69h1.14l.41,16.42,1.15,45.89C262.64,448.35,276.88,563.38,276.88,563.38Z",
    fill: "#2f2e41"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M216.26,78.77s13.24-4.71,16.26-10.35c0,0,1.41,9.13-3.06,11.91",
    fill: "#2f2e41"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M216.26,78.77s13.24-4.71,16.26-10.35c0,0,1.41,9.13-3.06,11.91",
    opacity: 0.2
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M255.8,120.19s-6.92-1.37-8.91-4.71a3.1,3.1,0,0,1,.33-3.53,62.16,62.16,0,0,0,9.67-17,1.74,1.74,0,0,1,1.91-1.07c2.87.52,9.24,2.28,11.3,7.9A75,75,0,0,0,255.8,120.19Z",
    fill: "#00c099"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M255.8,120.19s-6.92-1.37-8.91-4.71a3.1,3.1,0,0,1,.33-3.53,62.16,62.16,0,0,0,9.67-17,1.74,1.74,0,0,1,1.91-1.07c2.87.52,9.24,2.28,11.3,7.9A75,75,0,0,0,255.8,120.19Z",
    opacity: 0.2
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M256.89,94.91a49.84,49.84,0,0,0-4.54-8.72,10.07,10.07,0,0,0-7.95-4.47c-5.65-.25-15.14-.5-20.92.25,0,0-2.26,3,5.27,3,0,0,9.79,2.64,9.79,9.42,0,0,3,14.53,9.58,16.3A56.87,56.87,0,0,0,256.89,94.91Z",
    fill: "#f7a48b"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M231.76,76.7s0-7.15,4.14-5.27l8.45,6-8.45,3.42Z",
    fill: "#f7a48b"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M166.92,97.92l6.48-12.18s18.07-4.9,23-1.51c0,0,1.5,1.13-4.14,1.88,0,0-5.28.38-7.53,10.55,0,0-3.16,13.49-10.55,15.06Z",
    fill: "#f7a48b"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M167.37,97s7.91,12,12.43,3.39c0,0,4.14-12.42,8.28-14.31a10.63,10.63,0,0,1,5.91-.34s8.78.34,1.25-4.55c0,0,11.67,4.89,13.18,1.13,0,0,8.79-3.3-10.49-4.83a6.89,6.89,0,0,1-1.49-.29c-3.27-1-17.49-4.53-23.79,7.75Z",
    fill: "#f9b499"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 199,
    y1: 79.34,
    x2: 208.42,
    y2: 82.35,
    fill: "none",
    stroke: "#f7a48b",
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M248,331.43a47.67,47.67,0,0,1-10.63-9s-11.48-9.42-25.86-11.08l0-.09S241.23,300,248,331.43Z",
    opacity: 0.2
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M266.38,327.76a19.76,19.76,0,0,1-5.25-13.84c0-6.4,2.68-12,6.69-15.11A103,103,0,0,1,266,316.37S264.06,321.14,266.38,327.76Z",
    opacity: 0.2
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M262.24,353.51l-.17,0c-13.37,2.35-33.7-12.13-33.7-12.13-20-15.82-65.65-21.38-65.65-21.38l-.35-.83c.17-8.42.3-13.35.3-13.35l-.06-.35a12.28,12.28,0,0,0,5.83-.43c7.22,4.72,24.06,5.76,32.41,6,3,.08,4.87.06,4.87.06,16.94-.76,31.63,11.29,31.63,11.29a48.63,48.63,0,0,0,23.34,14.69h1.14Z",
    opacity: 0.2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211,393.56c-1.89-27.19-2.78-54.78-2.6-82,1.9,27.19,2.77,54.79,2.6,82Z"
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M153.82,621.18l40.29.38s.38-17.33-3-18.08c0,0,.37-15.44-15.44-13.55,0,0-9,.75-8.66,11.67C167,601.6,153.07,608.75,153.82,621.18Z",
    fill: "#00c099"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "194.11 625.32 153.82 625.32 153.82 621.18 194.11 621.55 194.11 625.32",
    fill: "#2f2e41"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M191.1,603.48s-4.52,13.18,3,18.08",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.4
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M247.58,620.8l74.93.38s-1.88-9.41-21.84-15.44c0,0-15.06-6.4-19.2-12,0,0,0-4.89-3-4.52a28.22,28.22,0,0,1-24.47.38S248.33,586.54,247.58,620.8Z",
    fill: "#00c099"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M249.92,596.35s11.8,7,7.74,24.75",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.4
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 247.58,
    y: 620.8,
    width: 74.93,
    height: 4.52,
    fill: "#2f2e41"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M155.05,105.24h0a1.2,1.2,0,0,1,0-2L165,97.39a1.37,1.37,0,0,1,1.91.53L177,116.72a2.36,2.36,0,0,1-.67,3l-4.5,3.37a1.28,1.28,0,0,1-2-.62l-.25-.76S161.56,108.18,155.05,105.24Z",
    fill: "#00c099"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M155.05,105.24h0a1.2,1.2,0,0,1,0-2L165,97.39a1.37,1.37,0,0,1,1.91.53L177,116.72a2.36,2.36,0,0,1-.67,3l-4.5,3.37a1.28,1.28,0,0,1-2-.62l-.25-.76S161.56,108.18,155.05,105.24Z",
    fill: "#fff",
    opacity: 0.4
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M254.85,92.52c-1.37,3.38-5.48,12-10.13,8a6.58,6.58,0,0,1-2-3.32c-.47-1.78-1.37-5.16-2.45-9.26a10.23,10.23,0,0,0-3.71-5.62,7.53,7.53,0,0,0-8.35-.82s-11.79,6.37-11.66-3a.92.92,0,0,1,.88-.92l21.14-1.07a14.12,14.12,0,0,1,11.36,4.73,28.44,28.44,0,0,1,5,8.77A3.51,3.51,0,0,1,254.85,92.52Z",
    fill: "#f9b499"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M655.55,611a13.46,13.46,0,0,1-1.54-.06l.09-1c.11,0,11.12,1,19.43-6.12,5.59-4.78,8.73-12.07,9.32-21.67a48.7,48.7,0,0,0-2.61-18.67c-2-5.91-4.54-16.82,1-23.34,4.17-4.92,12.1-6.47,23.58-4.61l-.16,1c-11.11-1.81-18.73-.37-22.66,4.26-5.21,6.16-2.74,16.66-.8,22.38a49.89,49.89,0,0,1,2.66,19.05c-.61,9.89-3.87,17.42-9.68,22.37C667.42,610.36,659,611,655.55,611Z",
    fill: "#2f2e41"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M596.19,246.33h-1V214.1a5.73,5.73,0,0,0-5.72-5.72H525.59v-1h63.88a6.73,6.73,0,0,1,6.72,6.72Z",
    fill: "#2f2e41"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M592.05,246.33h-1V218.28a5.72,5.72,0,0,0-5.72-5.71H525.28v-1h60.05a6.73,6.73,0,0,1,6.72,6.71Z",
    fill: "#2f2e41"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M547.8,246.74h-1v-16H525.35v-1H546.8v-3.78a4.78,4.78,0,0,1,4.78-4.77h.86a4.78,4.78,0,1,1,0,9.55H547.8Zm0-17h4.64a3.78,3.78,0,1,0,0-7.55h-.86a3.78,3.78,0,0,0-3.78,3.77Z",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.c75d02487d9cda287db7f864a5bc9a46.svg";
export { ForwardRef as ReactComponent };